<template>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-fullscreen-md-down modal-dialog-centered">
      <div class="modal-content border-ruderclub-dark-green">
        <div class="modal-header bg-ruderclub-dark-green">
          <h5 class="modal-title">
            {{ localTask.id ? "Aufgabe bearbeiten" : "Neue Aufgabe" }}
          </h5>
          <button
            type="button"
            class="btn-close bg-light"
            @click="$emit('close')"
          ></button>
        </div>
        <div class="modal-body">
          <input
            v-model="localTask.title"
            class="form-control mb-3"
            placeholder="Titel"
          />
          <div id="editor" class="mb-3"></div>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <button class="btn btn-outline-secondary" @click="$emit('close')">
            Abbrechen
          </button>
          <button
            @click="saveTask"
            class="btn btn-ruderclub-dark-green d-flex align-items-center"
          >
            <i class="material-symbols-outlined me-2">save</i>Speichern
          </button>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import Quill from "quill";
import { notify } from "@kyvg/vue3-notification";

export default {
  props: ["task"],
  data() {
    return {
      localTask: {
        id: this.task?.id || null,
        title: this.task?.title || "",
        description: this.task?.description || "",
      },
      editor: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.editor = new Quill("#editor", {
        theme: "snow",
      });

      document.getElementById("editor").style.minHeight = "90px";

      if (this.localTask.description) {
        this.editor.root.innerHTML = this.localTask.description;
      }
    });
  },
  methods: {
    saveTask() {
      const form = {
        id: this.localTask.id,
        title: this.localTask.title.trim(),
        description: this.editor.root.innerHTML.trim(),
      };

      if (
        !form.title ||
        form.title.length === 0 ||
        !form.description ||
        form.description.length === 0
      ) {
        notify({
          title: "Fehler",
          text: "Pflichtangaben fehlen.",
          type: "error",
          duration: 5000,
        });

        return;
      }

      this.$emit("save", form);
    },
  },
};
</script>

<style>
.modal-backdrop {
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
